import { axiosDefault } from '@/core/utils';
import {
	BuySkinResponseMapper,
	SelectSkinResponseMapper,
} from '@/core/mappers';
import { BuySkin, SelectSkin } from '@/core/interfaces';

const buySkin = async (id: string): Promise<BuySkin> => {
	const url = `/tg/product/skin/${id}/purchase`;
	const response = await axiosDefault.post(url, null);

	return {
		currentCoins: response.data.currentCoins,
		currentDiamonds: response.data.currentDiamonds,
		newDiamonds: response.data.newDiamonds,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
		skin: BuySkinResponseMapper(response.data.data),
	};
};

const activateSkin = async (id: string): Promise<SelectSkin> => {
	const url = `/tg/skin/${id}/select`;
	const response = await axiosDefault.post(url, null);

	return {
		currentCoins: response.data.currentCoins,
		currentDiamonds: response.data.currentDiamonds,
		newDiamonds: response.data.newDiamonds,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
		levels: SelectSkinResponseMapper(response.data.data),
	};
};

const deactivateSkin = async (id: string): Promise<SelectSkin> => {
	const url = `/tg/skin/${id}/select`;
	const response = await axiosDefault.post(url, null);

	return {
		currentCoins: response.data.currentCoins,
		currentDiamonds: response.data.currentDiamonds,
		newDiamonds: response.data.newDiamonds,
		isAwardWinning: response.data.isAwardWinning,
		totalCoinsEarned: response.data.totalCoinsEarned,
		levels: SelectSkinResponseMapper(response.data.data),
	};
};

export const SkinsService = {
	buySkin,
	activateSkin,
	deactivateSkin,
};
